<template>
  <div class="financial-health" redesign>
    <!-- Request stepper -->
    <RequestStepProgressBar isFinancialHealthSurvey />

    <div class="form-container financial-health-form">
      <div v-if="!loading" class="financial-health-form-header form-header">
        <translate>
          The following data is requested to help the {{organizationDetails.programName}} understand how it can better help
          participants, and will not impact grant decisions in any way.
        </translate>
      </div>
      <div class="survey-container">
        <LoadSpinner v-if="loading" :color="`#${organizationDetails.darkBrandColor}`" />
        <SurveyResponseComponent
          v-else
          @survey-done="onSurveyDone"
          :surveyResponse="surveyResponse"
          buttonText="Complete"
          nextStep="Request Summary"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SurveyResponse from '@/services/surveyresponses'
import SurveyResponseComponent from '@/components/SurveyResponse'
import { mapState } from 'vuex'
import LoadSpinner from '@/components/LoadSpinner'
import InfoBox from '@/components/InfoBox'
import UserEvent from '@/services/userEvents'
import RequestStepProgressBar from '@/components/stepper/RequestStepProgressBar'

export default {
  name: 'FinancialHealthOnboarding',
  components: {
    SurveyResponseComponent,
    LoadSpinner,
    InfoBox,
    RequestStepProgressBar,
  },
  data() {
    return {
      loading: null,
      surveyResponse: null,
      surveyName: 'Financial Health',
    }
  },
  async created() {
    this.loading = true
    const isComplete = await SurveyResponse.checkIfEmployeeHasCompleted(this.user, this.surveyName)
    // If user has already completed this survey, route to next page
    if (isComplete) {
      this.$router.push({ name: 'PayPalVerify' })
      // Otherwise, pull in a survey for them to complete
    } else {
      const surveyResponse = await SurveyResponse.getOrCreate(this.user, this.surveyName)
      this.surveyResponse = surveyResponse
    }
    this.loading = false
  },
  mounted() {
    // Update the current request completion status
    UserEvent.api.requestUpdateCompletionStatus(
      this.currentRequest.id,
      UserEvent.options.REQUEST_STEP_FINANCIAL_HEALTH,
    )
  },
  methods: {
    onSurveyDone(success) {
      if (success) {
        this.$router.push({ name: 'RequestSummary' })
      } else {
        this.$Alert.alert({
          type: 'error',
          message: `<h4>Something went wrong!</h4><p>Please try again later.</p>`,
          timeout: 6000,
        })
      }
    },
  },
  computed: {
    ...mapState(['user', 'organizationDetails', 'currentRequest']),
    content() {
      return this.$gettext('To make a grant request, please complete your') + ' ' + this.organizationDetails?.programName + ' ' + this.$gettext('profile by answering the questions below.')
    },
    displayName() {
      return this.$gettext('Financial Health')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';
@import '@/styles/mixins/responsive';

.financial-health {
  display: flex;
  flex-direction: column;

  .financial-health-form {
    @extend .constrain-tablet-and-up;
  }

  .financial-health-form-header {
    text-align: left;
  }
}
</style>
